module.exports = __webpack_public_path__ + "img/shixishenghuo.c15d7c43.png";